import * as tracking from 'dibs-tracking';

const CAROUSEL_NEXT_ACTION = 'pdp image carousel next button';
const CAROUSEL_PREV_ACTION = 'pdp image carousel previous button';
const CAROUSEL_CONTACT_DEALER = 'contact dealer - pdp image carousel';
const CAROUSEL_CLICK_ACTION = 'primary image click';
const CAROUSEL_CLICK_VIEW_ROOM = 'view in room clicked';
const CAROUSEL_DISPLAYED_VIEW_ROOM = 'view in room displayed';

const trackHeroEvent = ({ index, total, action, isInteractiveEvent }, event = null) => {
    let label = `${index + 1}/${total}`;
    if (index + 1 === total) {
        label = CAROUSEL_CONTACT_DEALER;
    }
    tracking.trackEvent(
        {
            action,
            category: 'product',
            label,
            isInteractiveEvent,
        },
        event
    );
};

export const trackChangeCarousel = ({ index, total, next }) =>
    trackHeroEvent({
        index,
        total,
        isInteractiveEvent: true,
        action: next ? CAROUSEL_NEXT_ACTION : CAROUSEL_PREV_ACTION,
    });

export const trackClickCarousel = ({ index, total }, event) =>
    trackHeroEvent(
        {
            index,
            total,
            action: CAROUSEL_CLICK_ACTION,
        },
        event
    );

export const trackViewRoomClick = ({ index, total }, event) =>
    trackHeroEvent(
        {
            index,
            total,
            action: CAROUSEL_CLICK_VIEW_ROOM,
        },
        event
    );

export const trackViewRoomDisplayed = ({ index, total }) =>
    trackHeroEvent({
        index,
        total,
        action: CAROUSEL_DISPLAYED_VIEW_ROOM,
    });
